import React from 'react';
import classnames from 'classnames/bind';
import style from './selected.module.scss';

import { useInterview } from '@components/pass/interview/start/context/interviewContext';
import InterviewPracticeQuestionList from '../../common/questionList';

const cx = classnames.bind(style);

const InterviewPracticeQuestionSelectBodySelected = () => {
  const { selectedQuestionList } = useInterview();
  const selectedQuestionCount = selectedQuestionList.length;

  return (
    <div className={cx('selectedWrap')}>
      <div className={cx('title')}>
        선택한 질문<span className={cx('highlightText')}> {selectedQuestionCount}</span>개
      </div>
      <div className={cx('divider')} />
      <InterviewPracticeQuestionList className={cx('questionList')} questionList={selectedQuestionList} />
    </div>
  );
};

export default InterviewPracticeQuestionSelectBodySelected;
